import { NgTemplateOutlet } from '@angular/common'
import { Component, computed, contentChild, input, TemplateRef } from '@angular/core'
import { DateComponent, DateFormat, IconComponent } from '@ftr/foundation'
import { CartGroup, CartItem } from '../../../store'

export const CartGroupDisplayTypes = ['small', 'large']
export type CartGroupDisplayType = (typeof CartGroupDisplayTypes)[number]

@Component({
  selector: 'ftr-request-cart-group',
  templateUrl: './request-cart-group.component.html',
  styleUrl: './request-cart-group.component.css',
  imports: [DateComponent, IconComponent, NgTemplateOutlet],
})
export class RequestCartGroupComponent {
  readonly group = input.required<CartGroup>()
  readonly displayType = input.required<CartGroupDisplayType>()

  readonly itemTemplate = contentChild.required<TemplateRef<{ $implicit: CartItem }>>('itemTemplate')

  protected readonly dateFormat = DateFormat

  protected classes = computed<string>(() => `cart-group cart-group--${this.displayType()}`)
}
